import { render } from "./CategoryManager.vue?vue&type=template&id=8641704a"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__